import { PageHeader } from '@/components/ui/page-header';
import { AppControl } from '../components/AppControl';
import { AppDownloads } from '../components/AppDownloads';
import { Card } from '../components/Facts';
import { useAppBinding, useAppBindings } from '../hooks';

/**
 * The Witina VPN apps connected as you, each with its sites' toggles
 * (docs/VpnAccess.md, "Slice 9 design"): the control page, reached from
 * Witina rather than from an app's link. A new app still connects through
 * its link, which it opens itself.
 */
export function VpnConnections() {
  const apps = useAppBindings();

  return (
    <div className="space-y-5">
      <PageHeader title="Connect" subtitle="Turn on the sites you need. Your Witina VPN app connects to each one." />
      {apps.isLoading ? (
        <p className="text-xs text-muted-foreground">Loading…</p>
      ) : apps.isError ? (
        <p className="text-xs text-muted-foreground">Couldn&rsquo;t load your apps.</p>
      ) : !apps.data?.length ? (
        <>
          <Card title="No app connected">
            <p className="text-sm">
              Open the Witina VPN app on the computer you&rsquo;re working from. It opens its link here, and then this
              page turns sites on and off for it. Don&rsquo;t have it yet? Download it below.
            </p>
          </Card>
          <AppDownloads />
        </>
      ) : (
        apps.data.map((app) => <ConnectedApp key={app.id} id={app.id} />)
      )}
    </div>
  );
}

/** One app, followed live, as its link's page follows it. */
function ConnectedApp({ id }: { id: string }) {
  const binding = useAppBinding(id);
  if (!binding.data) return <p className="text-xs text-muted-foreground">Loading…</p>;
  return <AppControl binding={binding.data} />;
}
